export const COUNTRIES = [
  {
    key: 'LV',
    title: 'countries.lv'
  },
  {
    key: 'LT',
    title: 'countries.lt'
  },
  {
    key: 'ET',
    title: 'countries.et'
  },
  {
    key: 'ZW',
    title: 'countries.other'
  }
]

export const LANGUAGES = [
  {
    key: 'LV',
    title: 'Latviešu'
  },
  {
    key: 'LT',
    title: 'Lietuvių'
  },
  {
    key: 'ET',
    title: 'Eesti'
  },
  {
    key: 'EN',
    title: 'English'
  }
]

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
